import React, { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import clsx from 'clsx';

export const GroupInfo = () => {
  const { getValues } = useFormContext();
  const [updatedBy, updatedDate] = getValues(['CreatedByName', 'CreatedAt']);

  return (
    <div className="flex justify-between my-8">
      <p className="font-effra font-normal text-black text-base">
        <span className="font-bold">Last updated by:</span> {updatedBy} {updatedDate}
      </p>
      <span className="font-effra font-normal text-black text-sm">* Required</span>
    </div>
  );
};

export const GroupGridRow = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <div className={clsx('grid grid-cols-12 gap-x-6 items-center', className)}>{children}</div>;
};

const GroupSectionLabel = ({ label }: { label: string }) => (
  <h3 className="pt-1 pb-6 font-effra font-medium">{label}</h3>
);

export const GroupGridRowWithLabel = ({ children, label }: { children: ReactNode; label: string }) => (
  <div className="flex flex-col">
    <GroupSectionLabel label={label} />
    <GroupGridRow>{children}</GroupGridRow>
  </div>
);
